var arrPhoneCodes = [
  'Afghanistan: 93',
  'Albania: 355',
  'Algeria: 213',
  'Andorra: 376',
  'Angola: 244',
  'Antigua and Barbuda: 1268',
  'Argentina: 54',
  'Armenia: 374',
  'Australia: 61',
  'Austria: 43',
  'Azerbaijan: 994',
  'Bahamas: 1242',
  'Bahrain: 973',
  'Bangladesh: 880',
  'Barbados: 1246',
  'Belarus: 375',
  'Belgium: 32',
  'Belize: 501',
  'Benin: 229',
  'Bhutan: 975',
  'Bolivia: 591',
  'Bosnia and Herzegovina: 387',
  'Botswana: 267',
  'Brazil: 55',
  'Brunei: 673',
  'Bulgaria: 359',
  'Burkina Faso: 226',
  'Burundi: 257',
  'Cambodia: 855',
  'Cameroon: 237',
  'Canada/United States: 1',
  'Cape Verde: 238',
  'Central African Republic: 236',
  'Chad: 235',
  'Chile: 56',
  'China: 86',
  'Colombia: 57',
  'Comoros: 269',
  'Congo, Democratic Republic: 243',
  'Congo, Republic: 242',
  'Costa Rica: 506',
  'Cote d`Ivoire: 225',
  'Croatia: 385',
  'Cuba: 53',
  'Cyprus: 357',
  'Czech Republic: 420',
  'Denmark: 45',
  'Djibouti: 253',
  'Dominica: 1767',
  'Dominican Republic: 1809',
  'East Timor: 670',
  'Ecuador: 593',
  'Egypt: 20',
  'El Salvador: 503',
  'Equatorial Guinea: 240',
  'Eritrea: 291',
  'Estonia: 372',
  'Ethiopia: 251',
  'Federated States of Micronesia: 691',
  'Fiji: 679',
  'Finland: 358',
  'France: 33',
  'Gabon: 241',
  'Gambia: 220',
  'Georgia: 995',
  'Germany: 49',
  'Ghana: 233',
  'Greece: 30',
  'Grenada: 1473',
  'Guatemala: 502',
  'Guinea: 224',
  'Guinea-Bissau: 245',
  'Guyana: 592',
  'Haiti: 509',
  'Honduras: 504',
  'Hungary: 36',
  'Iceland: 354',
  'India: 91',
  'Indonesia: 62',
  'Iran: 98',
  'Iraq: 964',
  'Ireland: 353',
  'Israel: 972',
  'Italy/Vatican City: 39',
  'Jamaica: 1876',
  'Japan: 81',
  'Jordan: 962',
  'Kazakhstan: 77',
  'Kenya: 254',
  'Kiribati: 686',
  'Kuwait: 965',
  'Kyrgyzstan: 996',
  'Laos: 856',
  'Latvia: 371',
  'Lebanon: 961',
  'Lesotho: 266',
  'Liberia: 231',
  'Libya: 218',
  'Liechtenstein: 423',
  'Lithuania: 370',
  'Luxembourg: 352',
  'Macedonia: 389',
  'Madagascar: 261',
  'Malawi: 265',
  'Malaysia: 60',
  'Maldives: 960',
  'Mali: 223',
  'Malta: 356',
  'Marshall Islands: 692',
  'Mauritania: 222',
  'Mauritius: 230',
  'Mexico: 52',
  'Moldova: 373',
  'Monaco: 377',
  'Mongolia: 976',
  'Montenegro/Serbia: 381',
  'Morocco: 212',
  'Mozambique: 259',
  'Myanmar: 95',
  'Namibia: 264',
  'Nauru: 674',
  'Nepal: 977',
  'Netherlands: 31',
  'New Zealand: 64',
  'Nicaragua: 505',
  'Niger: 227',
  'Nigeria: 234',
  'North Korea: 850',
  'Norway: 47',
  'Oman: 968',
  'Pakistan: 92',
  'Palau: 680',
  'Panama: 507',
  'Papua New Guinea: 675',
  'Paraguay: 595',
  'Peru: 51',
  'Philippines: 63',
  'Poland: 48',
  'Portugal: 351',
  'Qatar: 974',
  'Romania: 40',
  'Russia: 7',
  'Rwanda: 250',
  'S?o Tom? and Pr?ncipe: 239',
  'Saint Kitts and Nevis: 1869',
  'Saint Lucia: 1758',
  'Saint Vincent and the Grenadines: 1784',
  'Samoa: 685',
  'San Marino: 378',
  'Saudi Arabia: 966',
  'Senegal: 221',
  'Seychelles: 248',
  'Sierra Leone: 232',
  'Singapore: 65',
  'Slovakia: 421',
  'Slovenia: 986',
  'Solomon Islands: 677',
  'Somalia: 252',
  'South Africa: 27',
  'South Korea: 82',
  'Spain: 34',
  'Sri Lanka: 94',
  'Sudan: 249',
  'Suriname: 597',
  'Swaziland: 268',
  'Sweden: 46',
  'Switzerland: 41',
  'Syria: 963',
  'Tajikistan: 992',
  'Tanzania: 255',
  'Thailand: 66',
  'Togo: 228',
  'Tonga: 676',
  'Trinidad and Tobago: 1868',
  'Tunisia: 216',
  'Turkey: 90',
  'Turkmenistan: 993',
  'Tuvalu: 688',
  'Uganda: 256',
  'Ukraine: 380',
  'United Arab Emirates: 971',
  'United Kingdom: 44',
  'Uruguay: 598',
  'Uzbekistan: 998',
  'Vanuatu: 678',
  'Venezuela: 58',
  'Vietnam: 84',
  'Yemen: 967',
  'Zambia: 260',
  'Zimbabwe: 263'
]

function convertCodesForSelect () {
  return arrPhoneCodes.map((item) => {
    let countryData = item.split(': ')
    return { text: `${countryData[0]} (+${countryData[1]})`, value: countryData[1] }
  })
}

export default {
  defaultSiteAddress: 1,
  windowWidth: 0,
  windowHeight: 0,
  totalProjects: 0,
  totalKeywords: 0,
  totalLinks: 0,
  totalReports: 0,
  totalProxies: 0,
  totalUsers: 0,
  totalGoals: 0,
  engines: null,
  enginesById: null,
  selectEngines: [
    {
      id: 0,
      name: 'google.com',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-US',
      value: 0,
      text: 'google.com'
    },
    {
      id: 1,
      name: 'google.co.il',
      value: 1,
      text: 'google.co.il',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-IL'
    },
    {
      id: 2,
      name: 'google.co.il (mobile)',
      value: 2,
      text: 'google.co.il (mobile)',
      device_css: 'icon-screen-smartphone',
      country_css: 'fa bfh-flag-IL'
    },
    {
      id: 3,
      name: 'google.co.uk',
      value: 3,
      text: 'google.co.uk',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-GB'
    },
    {
      id: 4,
      name: 'google.ru',
      value: 4,
      text: 'google.ru',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-RU'
    },
    {
      id: 5,
      name: 'google.ru (mobile)',
      value: 5,
      text: 'google.ru (mobile)',
      device_css: 'icon-screen-smartphone',
      country_css: 'fa bfh-flag-RU'
    },
    {
      id: 6,
      name: 'google.com.tr',
      value: 6,
      text: 'google.com.tr',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-TR'
    },
    {
      id: 7,
      name: 'google.com.tr (mobile)',
      value: 7,
      text: 'google.com.tr (mobile)',
      device_css: 'icon-screen-smartphone',
      country_css: 'fa bfh-flag-TR'
    }
  ],
  selectEnginesAll: [
    {
      id: 0,
      name: 'google.com',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-US',
      value: 0,
      text: 'google.com'
    },
    {
      id: 1,
      name: 'google.co.il',
      value: 1,
      text: 'google.co.il',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-IL'
    },
    {
      id: 2,
      name: 'google.co.il (mobile)',
      value: 2,
      text: 'google.co.il (mobile)',
      device_css: 'icon-screen-smartphone',
      country_css: 'fa bfh-flag-IL'
    },
    {
      id: 3,
      name: 'google.co.uk',
      value: 3,
      text: 'google.co.uk',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-GB'
    },
    {
      id: 4,
      name: 'google.ru',
      value: 4,
      text: 'google.ru',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-RU'
    },
    {
      id: 5,
      name: 'google.ru (mobile)',
      value: 5,
      text: 'google.ru (mobile)',
      device_css: 'icon-screen-smartphone',
      country_css: 'fa bfh-flag-RU'
    },
    {
      id: 6,
      name: 'google.com.tr',
      value: 6,
      text: 'google.com.tr',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-TR'
    },
    {
      id: 7,
      name: 'google.com.tr (mobile)',
      value: 7,
      text: 'google.com.tr (mobile)',
      device_css: 'icon-screen-smartphone',
      country_css: 'fa bfh-flag-TR'
    }
  ],
  selectAllEngines: [
    {
      id: 0,
      name: 'google.com',
      value: 0,
      text: 'google.com',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-US'
    },
    {
      id: 1,
      name: 'google.co.il',
      value: 1,
      text: 'google.co.il',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-IL'
    },
    {
      id: 2,
      name: 'google.co.il (mobile)',
      value: 2,
      text: 'google.co.il (mobile)',
      device_css: 'icon-screen-smartphone',
      country_css: 'fa bfh-flag-IL'
    },
    {
      id: 3,
      name: 'google.co.uk',
      value: 3,
      text: 'google.co.uk',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-GB'
    },
    {
      id: 4,
      name: 'google.ru',
      value: 4,
      text: 'google.ru',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-RU'
    },
    {
      id: 5,
      name: 'google.ru (mobile)',
      value: 5,
      text: 'google.ru (mobile)',
      device_css: 'icon-screen-smartphone',
      country_css: 'fa bfh-flag-RU'
    },
    {
      id: 6,
      name: 'google.com.tr',
      value: 6,
      text: 'google.com.tr',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-TR'
    },
    {
      id: 7,
      name: 'google.com.tr (mobile)',
      value: 7,
      text: 'google.com.tr (mobile)',
      device_css: 'icon-screen-smartphone',
      country_css: 'fa bfh-flag-TR'
    }
  ],
  selectReports: [
    { id: 0, name: 'Competitor', value: 0, text: 'Competitor' },
    { id: 1, name: 'Ranking', value: 1, text: 'Ranking' },
    { id: 2, name: 'Pages Performance', value: 2, text: 'Pages Performance' },
    { id: 3, name: 'Link Profiler', value: 3, text: 'Link Profiler' },
    { id: 4, name: 'Subfinder', value: 4, text: 'Subfinder' },
    { id: 5, name: 'Potential Traffic', value: 5, text: 'Potential Traffic' },
    { id: 6, name: 'Visibility', value: 6, text: 'Visibility' },
    { id: 7, name: 'Losers', value: 7, text: 'Losers' },
    { id: 8, name: 'Winners', value: 8, text: 'Winners' }
  ],
  userRoles: {},
  selectUserRoles: [
    {
      id: 0,
      name: 'client'
    },
    {
      id: 1,
      name: 'member'
    },
    {
      id: 2,
      name: 'admin'
    }
  ],
  reports: null,
  reportsById: null,
  schemaSelect: [
    { name: 'http', id: 0 },
    { name: 'https', id: 1 },
    { name: 'ftp', id: 2 },
    { name: 'socks5', id: 3 }
  ],
  schemas: ['http', 'https', 'ftp', 'socks5'],
  currencySign: {
    USD: '$',
    ILS: '₪',
    NIS: '₪'
  },
  currencies: {
    1: 'NIS',
    2: 'USD'
  },
  plansNames: {
    trial: 'Trial',
    wordpress: 'Wordpress',
    smb: 'SMB',
    seo: 'SEO',
    flexLite: 'Flex Lite',
    flex: 'Flex'
  },
  plansPricing: {
    trial: 'Trial',
    wordpress: 'Wordpress',
    smb: 'SMB',
    seo: 'SEO',
    flexLite: 'Flex Lite',
    flex: 'Flex'
  },
  chartColors: [
    '#5ee1c6',
    '#5ab1ef',
    '#ADD8E6',
    '#feb08d',
    '#778899',
    '#90EE90',
    '#FFC0CB',
    '#5F9EA0',
    '#DEB887',
    '#6495ED',
    '#008B8B',
    '#da70d6',
    '#32cd32',
    '#9ACD32',
    '#cd5c5c',
    '#ffa500',
    '#40e0d0',
    '#1e90ff',
    '#7b68ee',
    '#00fa9a',
    '#ffd700',
    '#3cb371',
    '#b8860b',
    '#808000',
    '#D8BFD8',
    '#30e0e0'
  ],
  phoneCodes: convertCodesForSelect(),
  chartPermsNames: {
    0: 'ranking_chart_type',
    1: 'traffic_chart_type',
    2: 'averages_chart_type',
    3: 'keywords_count_chart_type',
    5: 'indexed_pages_chart_type'
  },
  weatherPerms: {
    noWeather: 0,
    general: 10,
    personalGeneral: 20,
    categoryGeneral: 30
  },
  chartTypes: {
    RANKING: 0,
    TRAFFIC: 1,
    AVERAGES: 2,
    KEYWORDS_COUNT: 3,
    DOMAIN_RANK: 4,
    INDEXED_PAGES: 5,
    CHANGES: 6,
    KEYWORD_URK_RANKING: 7,
    KEYWORD_RANKING_STABILITY: 8,
    KEYWORDS_FEATURED_SNIPPETS: 9,
    KEYWORD_VOLUMES: 10,
    TOTAL_CPC: 11,
    KEYWORDS_CATEGORY_CHART: 12
  },
  chartTypesSelect: [
    {text: 'Ranking', value: 0},
    {text: 'Traffic estimation ( for selected keywords )', value: 1},
    {text: 'Average rank', value: 2},
    {text: 'Domain keywords count', value: 3},
    {text: 'Kolyom Domain Rank', value: 4},
    {text: 'Indexed pages count', value: 5}
  ],
  globalSearchTypes: {
    projects: 0,
    keywords: 1
  },
  userOfferTypes: {
    Other: 0,
    Payments: 1,
    Goal: 2,
    Bug: 3,
    WrongRanking: 4,
    WrongEngine: 5,
    NewCategory: 6
  },
  userOfferTypesSelect: [
    { text: 'Other', value: 0 },
    { text: 'Payments', value: 1 },
    { text: 'Goal', value: 2 },
    { text: 'Bug', value: 3 },
    { text: 'Wrong Ranking', value: 4 },
    { text: 'Wrong Engine', value: 5 },
    { text: 'New Category', value: 6 }
  ],
  userOfferUrgency: {
    Nomatter: 0,
    Normal: 1,
    Urgent: 2,
    Immediate: 3
  },
  userOfferUrgencySelect: [
    { text: 'No matter', value: 0 },
    { text: 'Normal', value: 1 },
    { text: 'Urgent', value: 2 },
    { text: 'Immediate', value: 3 }
  ],
  importanceRangeType: {
    LowerThan1: 0,
    From1to15: 1,
    From15to30: 2,
    From30to50: 3,
    From50to100: 4,
    From100to300: 5,
    GreaterThan300: 6
  },
  importanceRangeTypeText: {
    0: '< 1',
    1: '1-15',
    2: '15-30',
    3: '30-50',
    4: '50-100',
    5: '100-300',
    6: '300+'
  },
  historyMonths: {
    10: 0,
    20: 1,
    30: 3,
    40: 6,
    50: 12
  },
  errorReporsTypes: {
    BadApiUsageError: 0,
    PaymentSystemError: 1,
    PaymentRequiredError: 2,
    UserPermissionError: 3,
    NotFoundError: 4,
    InternalApiError: 5,
    UnknownError: 100
  },
  errorReporsTypesSelect: [
    { text: 'All Errors', value: null },
    { text: 'Bad Api Usage Error', value: 0 },
    { text: 'Payment System Error', value: 1 },
    { text: 'Payment Required Error', value: 2 },
    { text: 'User Permission Error', value: 3 },
    { text: 'Not Found Error', value: 4 },
    { text: 'Internal Api Error', value: 5 },
    { text: 'Unknown Error', value: 100 }
  ],
  keywordSuggestionTypesSelect: [
    { text: 'No Suggestions', value: 0 },
    { text: 'Related', value: 10 },
    { text: 'Broad Terms', value: 20 },
    { text: 'Category', value: 30 }
  ],
  weatherGraphTypeSelect: [
    { text: 'No Weather', value: 0 },
    { text: 'General', value: 10 },
    { text: 'Personal General', value: 20 },
    { text: 'Category General', value: 30 }
  ],
  dateRangeTypeSelect: [
    { text: 'Unavailable', value: 0 },
    { text: 'Week', value: 10 },
    { text: 'Month', value: 20 },
    { text: 'Three Months', value: 30 },
    { text: 'Six Months', value: 40 },
    { text: 'Year', value: 50 }
  ],
  rankingAveragesDateRangeTypeSelect: [
    { text: 'Unavailable', value: 0 },
    { text: 'Weekly', value: 10 },
    { text: 'Monthly', value: 20 },
    { text: 'Quarterly', value: 30 }
  ],
  rankingTrendsFilterTypeSelect: [
    { text: 'Rank Same', value: 0 },
    { text: 'Rank Up', value: 1 },
    { text: 'Rank Down', value: 2 },
    { text: 'Not Stable', value: 3 },
    { text: 'More Than One URL', value: 4 },
    { text: 'More Than One Link', value: 5 },
    { text: 'Cannibalization URLs', value: 6 },
    { text: 'Exited First Page', value: 7 },
    { text: 'Entered', value: 8 },
    { text: 'Switching URLs', value: 9 }
  ],
  changesTabUrlFilterTypeSelect: [
    { text: 'Cannibalization URLs', value: 6 },
    { text: 'Switching URLs', value: 9 }
  ],
  weeklyScansSelect: [
    { text: '1 per week', value: 1 },
    { text: '7 per week', value: 7 }
  ],
  linksPeriodSelect: [
    { text: '0', value: 0 },
    { text: '1 per week', value: 1 },
    { text: '7 per week', value: 7 }
  ],
  scrapingDepthSelect: [
    { text: '30 results', value: 30 },
    { text: '50 results', value: 50 },
    { text: '100 results', value: 100 }
  ],
  reportLinesLimitSelect: [
    { text: '0 lines', value: 0 },
    { text: '25 lines', value: 25 },
    { text: '100 lines', value: 100 },
    { text: '500 lines', value: 500 },
    { text: 'Unlimited', value: -1 }
  ]
}



// WEBPACK FOOTER //
// ./src/store/metadata/state.js